import { Link } from "react-router-dom";
import { Column } from "react-table";
import { formatDate } from "../../api/DateUtils";
import {
  GetLicensingActionsByLicenceFetchUrl,
  ILicensingActionRow,
} from "../../api/ILicensingAction";
import { Grid } from "../Grid";
import { LicensingActionsGridProps } from "./LicensingActionsGridProps";
import { CreateStaticSelectColumnFilter } from "../../leap-components/Grid/FetchGrid/StaticSelectColumnFilter";

const LicensingActionsGrid = ({
  licenceId,
  licenceProfile,
  licensingActionTypes,
  licensingActionStatuses,
}: LicensingActionsGridProps) => {
  const GetUrlForLicensingAction = (
    profileNumber: string,
    licenceId: string,
    licensingActionId: string
  ) => {
    return `/licence-profile/${profileNumber}/versions/${licenceId}/licensing-actions/${licensingActionId}`;
  };

  //versions/:licenceId/licensing-actions/:licenceActionId

  const getFetchUrlFactory = (relatedId: string) => {
    let fetchUrlFn = (
      pageNo: number,
      recordsPerPage: number,
      searchText: string,
      filters: any
    ) => {
      return GetLicensingActionsByLicenceFetchUrl(
        relatedId,
        pageNo,
        recordsPerPage,
        searchText,
        filters
      );
    };

    return fetchUrlFn;
  };

  const fetchUrl = getFetchUrlFactory(licenceId);

  const tableColumnsBig: Column<Record<string, ILicensingActionRow>>[] = [
    {
      Header: "Ref. No.",
      accessor: "code",
      Filter: false,
      filter: "code",
      Cell: (rowInfo: any) => (
        <table>
          <tr>
            <td>
              <Link
                to={GetUrlForLicensingAction(
                  licenceProfile.profileNo,
                  rowInfo.row.original.licenceid,
                  rowInfo.row.original.licenceactionid
                )}
              >
                {rowInfo.value}
              </Link>
            </td>
          </tr>
        </table>
      ),
    },
    {
      Header: "Name",
      accessor: "name",
      Filter: false,
    },
    {
      Header: "Type",
      accessor: "type",
      Filter: CreateStaticSelectColumnFilter(
        licensingActionTypes.list.map((option) => option.value)
      ),
    },
    {
      Header: "Status",
      accessor: "status",
      Filter: CreateStaticSelectColumnFilter(
        licensingActionStatuses.list.map((option) => option.value)
      ),
    },
    {
      Header: "Issued Date",
      accessor: "issueddate",
      Filter: false,
      filter: "includes",
      Cell: (rowInfo: any) => formatDate(rowInfo.value),
    },
    {
      Header: "Replied on Date",
      accessor: "repliedondate",
      Filter: false,
      filter: "includes",
      Cell: (rowInfo: any) => formatDate(rowInfo.value),
    },
  ];

  const tableColumnsSmall: Column<Record<string, ILicensingActionRow>>[] = [
    {
      Header: "Ref. No.",
      accessor: "code",
      Filter: false,
      filter: "code",
      Cell: (rowInfo: any) => (
        <table>
          <tr>
            <td>
              <Link
                to={GetUrlForLicensingAction(
                  licenceProfile.profileNo,
                  rowInfo.row.original.licenceid,
                  rowInfo.row.original.licenceactionid
                )}
              >
                {rowInfo.value}
              </Link>
            </td>
          </tr>
        </table>
      ),
    },
    {
      Header: "Name",
      accessor: "name",
      Filter: false,
    },
  ];

  var bodyElements = (
    <div>
      <div className="d-md-none">
        <Grid
          columns={tableColumnsSmall}
          data={[]}
          fetchUrlFunction={fetchUrl}
          enablePagination={true}
          enableQuickFind={true}
        />
      </div>
      <div className="d-none d-md-block">
        <Grid
          columns={tableColumnsBig}
          data={[]}
          fetchUrlFunction={fetchUrl}
          enablePagination={true}
          enableQuickFind={true}
        />
      </div>
    </div>
  );

  return bodyElements;
};

export { LicensingActionsGrid };
